import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { MarketPage, SiteStyle } from '@/interface/enum';
import { useAsiaSportMarketInfoStore } from '@/store/asiaSportMarketInfoStore';
import { useToggleStore } from '@/store/toggleStore';

export function useDynamicMarket() {
    const { isDynamicMarketEnabled: _isDynamicMarketEnabled, dynamicMarketsSportTypes } = storeToRefs(useToggleStore(SiteStyle.Asia));
    const { marketPage, sportType } = storeToRefs(useAsiaSportMarketInfoStore());

    const isDynamicMarketEnabled = computed(() => _isDynamicMarketEnabled.value
        && dynamicMarketsSportTypes.value.includes(sportType.value)
        && marketPage.value !== MarketPage.MixParlay);

    return { isDynamicMarketEnabled };
}
